import './themeDefaults';

export default () => ({
  root: {
    position: 'absolute',
    left: 0,
    top: 0,
    background: 'transparent',
    width: '100%',
    height: 30,
    border: 0,
    cursor: 'grab',
    '&:focus': {
      outline: 'none'
    }
  }
});
